interface PreviewCaptionProps {
  /** Формат кадра, как он уйдёт в публикацию: «1080×1920». */
  size: string;
  fontName?: string;
  fontSize?: number | null;
  /** Прозрачность плашки, 0…1. */
  backgroundAlpha?: number;
  /** Подсказка о зоне, которую перекроет интерфейс соцсети. */
  safeZoneHint?: string;
}

/**
 * Подпись под превью: что именно сейчас увидит зритель. Без неё приходится
 * искать цифры обратно в настройках, а часть из них (кегль при авто-подборе)
 * в настройках вообще не показана.
 */
export function PreviewCaption({
  size,
  fontName,
  fontSize,
  backgroundAlpha,
  safeZoneHint,
}: PreviewCaptionProps): JSX.Element {
  const parts = [size];
  if (fontName) parts.push(fontSize ? `${fontName} ${Math.round(fontSize)} px` : fontName);
  else if (fontSize) parts.push(`${Math.round(fontSize)} px`);
  if (backgroundAlpha != null && backgroundAlpha < 1) {
    parts.push(`Плашка ${Math.round(backgroundAlpha * 100)}%`);
  }

  return (
    <div className="mt-3 space-y-1">
      <p className="text-xs text-muted-foreground">{parts.join(' · ')}</p>
      {safeZoneHint && (
        <p className="text-xs text-muted-foreground/80">{safeZoneHint}</p>
      )}
    </div>
  );
}
